'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _redux = require('redux');

var _package = require('../actions/package');

var INITIAL_STATE = {
    isPosting: false,
    isFetching: false,
    items: []
};
var packages = function packages() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : INITIAL_STATE;
    var action = arguments[1];

    switch (action.type) {
        case _package.POST_PACKAGE_REQUEST:
            return _extends({}, state, {
                isPosting: true
            });
        case _package.POST_PACKAGE_SUCCESS:
            return _extends({}, state, {
                isFetching: false
            });
        case _package.POST_PACKAGE_FAILURE:
            return _extends({}, state, {
                isFetching: false,
                error: action.error
            });
        default:
            return state;
    }
};

var packageReducer = (0, _redux.combineReducers)({
    packages: packages
});

exports.default = packageReducer;


//////////////////
// WEBPACK FOOTER
// ./src/js/reducers/package.js
// module id = 907
// module chunks = 0